import { AxiosError, AxiosResponse } from "axios";
import { RESPONSE_CODES } from "../constants/responseCodes.constants";
import { api } from "../http"
import { SystemUserTypes, DefaultRes, CustomerTypes } from "../types";
import { OnboardingTypes } from "../types/onboarding.types";

export namespace OnboardingService {

    export const getCustomerProcessByUUID = async (
        uuid: string,
        callback: (isValid?: boolean, message?: string, result?: OnboardingTypes.InviteInfo | undefined) => void,
    ) => {
        try {
            // call the api with api seervice...
            const { data: { result, isValid, message }} = await api.get<
                DefaultRes<OnboardingTypes.InviteInfo>,
                AxiosResponse<DefaultRes<OnboardingTypes.InviteInfo>>
            >(`/customer/onboarding/getInviteDetails/${uuid}`);

            callback(isValid, message, result);

        } catch (error: any) {
            if (error.response) {
                const ERROR_CODE = (error as AxiosError<
                    DefaultRes<OnboardingTypes.InviteInfo>
                >).response?.data?.message;

                return callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            return callback && callback(false, String(error));
        }
    }
}